import RolesLink from 'components/pages/companies/team/roles-link'
export default RolesLink
